import { MY_JOBS_PATH, type ClockInAnswer, type ClockOutAnswer, type SubmitDayAnswer, type TravelAnswer, type VisitTapAnswer } from '@bms2/shared';

/**
 * My Jobs' routes and the shape of what a clock press told (piece 29), apart from the page so that a visit's page,
 * which presses the same routes, reads them without My Jobs (T3600; decision 10641).
 */
/** 🔨 Relative to the API's own root, never prefixed with /api (piece 1); the board's path and its builders live in `@bms2/shared`. */
/** 🔨 Clock In and Clock Out act for the viewer's own employment alone (decision 0127). */
export const MY_JOBS_CLOCK_IN_PATH = `${MY_JOBS_PATH}/clock-in`;
export const MY_JOBS_CLOCK_OUT_PATH = `${MY_JOBS_PATH}/clock-out`;
export const MY_JOBS_TRAVEL_PATH = `${MY_JOBS_PATH}/travel`;
export const MY_JOBS_SUBMIT_DAY_PATH = `${MY_JOBS_PATH}/submit-day`;
export const myJobsSubmitDayPath = (timeZone: string): string => `${MY_JOBS_SUBMIT_DAY_PATH}?timeZone=${encodeURIComponent(timeZone)}`;
/** 🔒 Decision 3072 (T2183): the viewer opened their own board and saw these jobs, so the menu's count of new jobs clears. */
export const MY_JOBS_SEEN_PATH = `${MY_JOBS_PATH}/seen`;

/** What the last clock press moved, said on the screen (piece 29: the screen says so). */
export type Told = { kind: 'in'; answer: ClockInAnswer } | { kind: 'out'; answer: ClockOutAnswer } | { kind: 'tap'; answer: VisitTapAnswer } | { kind: 'travel'; answer: TravelAnswer } | { kind: 'submitted'; answer: SubmitDayAnswer };
